import { AfterViewInit, Component, Input } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import * as bootstrap from "bootstrap";

@Component({
    selector: 'readonly-schema-dialog',
    imports: [TranslocoDirective],
    templateUrl: './readonly-schema-dialog.component.html',
    styleUrl: './readonly-schema-dialog.component.scss'
})
export class ReadonlySchemaDialogComponent implements AfterViewInit {
    @Input() readonly!: boolean | undefined;

    readOnlySchemaDialog: bootstrap.Modal | undefined;

    ngAfterViewInit(): void {
        const dialogElement = document.getElementById("readOnlySchemaDialog") as HTMLElement;
        this.readOnlySchemaDialog = bootstrap.Modal.getOrCreateInstance(dialogElement);
        
        if (this.readonly) {
            this.readOnlySchemaDialog?.show();
        }
    }

}
